<template>
  <div>
    <div class="pa-1">
      <v-layout wrap row>
        <v-flex xs12 sm4 class="pr-3">
          <OverviewFilter @onFilter="onFilter"></OverviewFilter>
        </v-flex>
        <v-flex xs12 sm8 class="pl-5">
          <dashboard-graph-loading v-if="loading"></dashboard-graph-loading>
          <template v-if="series">
            <apexchart
              ref="behaviorReportChart"
              type="pie"
              :width="chartWidth"
              :options="behaviorReportChart"
              :series="series"
            >
            </apexchart>
          </template>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import moment from 'moment'
import VueApexCharts from 'vue-apexcharts'
import DashboardGraphLoading from '@/components/view/dashboard/DashboardGraphLoading'
import OverviewFilter from '@/components/view/template/lamy/PurchaseBehavior/OverviewFilter.vue'

export default {
  props: ['selectedDate'],
  data: function () {
    return {
      loading: false,
      filter: {
        product: '',
        model: '',
        headtype: '',
        color: '',
        size: ''
      },
      series: [],
      behaviorReportChart: {
        chart: {
          type: 'pie'
        },
        labels: [],
        tooltip: {
          y: {
            formatter: function (val) {
              return val + ' คน'
            }
          }
        }
      }
    }
  },
  components: {
    DashboardGraphLoading,
    apexchart: VueApexCharts,
    OverviewFilter
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    }),
    chartWidth() {
      if (window.innerWidth < 500) {
        return 300
      } else {
        return 500
      }
    }
  },
  mounted: function () {
    this.getBehaviorReportAsked()
  },
  methods: {
    getBehaviorReportAsked() {
      const vm = this
      const data = {
        pageid: vm.selectedBot.pageid, // required
        start_date: moment(vm.selectedDate.start).format('YYYY-MM-DD'), // YYYY-MM-DD
        end_date: moment(vm.selectedDate.end).format('YYYY-MM-DD') // YYYY-MM-DD
      }

      if (vm.filter.product) {
        Object.assign(data, { product: vm.filter.product })
      }
      if (vm.filter.model) {
        Object.assign(data, { model: vm.filter.model })
      }
      if (vm.filter.headtype) {
        Object.assign(data, { colour: vm.filter.headtype })
      }
      if (vm.filter.color) {
        Object.assign(data, { colour: vm.filter.color })
      }
      if (vm.filter.size) {
        Object.assign(data, { size: vm.filter.size })
      }

      vm.loading = true
      api.getLamyBehaviorReportAsked(data, (err, response) => {
        if (response.responsecode == 200) {
          var chartData = response.data[0]
          let label = []
          let data = []

          $.each(chartData, function (index, val) {
            // label.push(index.split('_')[1] + ':00')
            if (!index.includes('count')) {
              var text
              switch (index) {
                case 'age_10_20':
                  text = 'อายุ 10-20 ปี'
                  break
                case 'age_21_30':
                  text = 'อายุ 21-30 ปี'
                  break
                case 'age_31_40':
                  text = 'อายุ 31-40 ปี'
                  break
                case 'age_41_50':
                  text = 'อายุ 41-50 ปี'
                  break
                case 'age_51':
                  text = 'อายุ 51 ปีขึ้นไป'
                  break
                case 'age_unknow':
                  text = 'คนที่เป็นสมาชิก แต่ไม่ทราบอายุ'
                  break
                case 'age_non_member':
                  text = 'คนที่ไมใช่สมาชิก'
                  break
                default:
                  text = 'Unknown'
              }
              label.push(text)
            } else {
              data.push(val)
            }
          })

          vm.$nextTick(function () {
            if (vm.$refs.behaviorReportChart) {
              vm.$refs.behaviorReportChart.updateOptions({
                labels: label
              })
              vm.series = data
            }
          })

          vm.loading = false
        } else {
          console.log(err)
          return
        }
      })
    }, //end getBehaviorReportAsked()
    onFilter(payload) {
      this.filter = {
        product: payload.product,
        model: payload.model,
        headtype: payload.headType,
        color: payload.color,
        size: payload.size
      }
      this.getBehaviorReportAsked()
    }
  },
  watch: {
    loading: function () {},
    selectedDate: {
      handler: function (newValue) {
        this.getBehaviorReportAsked()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/customize/lamy/LamyBehaviorReportAsked.vue